import { THEME_OPTIONS } from 'foundations-theming-base/theme-options';
import { removeDevOnlyThemeSetting } from './themeSwitcher';

export const isTrustedThemeSelectionSource = (
  event: MessageEvent,
  targetWindow: Window = window
): boolean =>
  event.source === targetWindow ||
  event.source === targetWindow.parent ||
  (event.origin !== 'null' && event.origin === targetWindow.location.origin);

export const applyThemeSelection = (key: string): boolean => {
  const theme = THEME_OPTIONS.find((option) => option.key === key);
  if (!theme) {
    return false;
  }

  removeDevOnlyThemeSetting();

  const { dataset } = document.documentElement;
  dataset.hubspotTheme = theme.legacyFallback;
  dataset.hubspotThemeName = theme.themeName;
  dataset.hubspotThemeMode = theme.themeMode;
  dataset.hubspotModernTheme = theme.themeMode;
  return true;
};
